import React, { useEffect, useState } from "react";
import styles from "./AddQuestions.module.css";
import {
  DropDown,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import { AiFillPlusCircle, AiOutlineClose } from "react-icons/ai";
import { GrAdd } from "react-icons/gr";
import { AiOutlineCheck } from "react-icons/ai";
import { BsCheck } from "react-icons/bs";
import { IoMdAdd } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Row } from "antd";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";
import Question from "./question/Question";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import {
  ClearRSVP,
  getQna,
  getTidbits,
} from "../../../../Store/Actions/EventPlanningActions";

const CloseIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 28 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.0773 23.0073L19.7087 15.0542L27.0775 7.10081L21.103 0.652335L13.7342 8.60568L6.36558 0.652567L0.390883 7.10123L7.75946 15.0543L0.390667 23.0077L6.36519 29.4562L13.734 21.5028L21.1026 29.4559L27.0773 23.0073Z"
      fill="#ED73AA"
    />
  </svg>
);

const questions = [
  {
    id: 1,
    question: "When is the RSVP deadline?",
    type: "Description",
    desc: "Please RSVP by April 15th, so we can have an accurate headcount. :)Best day ever fee...",
    isOpen: false,
  },
  {
    id: 2,
    question: "Will you be able to Join us at our wedding?",
    type: "Multiple Choice",
    options: ["Joyfully Accept"],
    isOpen: false,
  },
  {
    id: 3,
    question: "Will you be able to Join us at our wedding?",
    type: "Checkbox",
    options: ["Joyfully Accept"],
    isOpen: false,
  },
];

const AddQuestions = () => {
  const [isSelect, setIsSelect] = useState(false);
  const { state } = useLocation();
  const getTidbit = useSelector((state) => state.EventPlanningReducer.Tidbits);
  const Qna = useSelector((state) => state.EventPlanningReducer.Qna);
  const [currentQues, setCurrentQues] = useState(
    state.headrTitle == "Add Tidbits" ? getTidbit[0] : Qna[0]
  );
  const [allQuestions, setAllQuestions] = useState(
    state.headrTitle == "Add Tidbits" ? getTidbit : Qna
  );
  console.log("allQuestions", allQuestions);

  const [isAdd, setIsAdd] = useState(false);
  const [ID, setID] = useState();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  dispatch(
    state.headrTitle == "Add Tidbits"
      ? getTidbits(allQuestions)
      : dispatch(getQna(allQuestions))
  );
  const option = [
    { value: "multiple choice", option: "Multiple Choice" },
    { value: "description", option: "Description" },
    { value: "options", option: "Options" },
  ];
  const getIndex = () => {
    return allQuestions.findIndex((ques) => ques.id === currentQues.id);
  };
  // useEffect(()=>{
  // dispatch(ClearRSVP())
  // }, [])
  const addNewQuestion = () => {
    setAllQuestions((prev) => [...prev, currentQues]);
    setCurrentQues(currentQues);
    setIsAdd(false);
  };
  const done = () => {
    let array = [currentQues];
    if (
      !array[array.length - 1].question ||
      !array[array.length - 1].answerType
    ) {
      dispatch(
        showAlert({
          title: "Question",
          message: "Please fill Question first!",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (
      (array[array.length - 1].answerType == "Options" ||
        array[array.length - 1].answerType == "Multiple Choice") &&
      array[array.length - 1].options.length == 0
    ) {
      dispatch(
        showAlert({
          title: "Question",
          message: "Please fill option first!",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else {
      setAllQuestions((prev) => [...prev, currentQues]);
      setCurrentQues(currentQues);
      setIsAdd(false);
      navigate(-1);
    }
  };

  const updateQuestions = () => {
    let array = [currentQues];
    if (
      !array[array.length - 1].question ||
      !array[array.length - 1].answerType
    ) {
      dispatch(
        showAlert({
          title: "Question",
          message: "Please fill Question first!",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (
      (array[array.length - 1].answerType == "Options" ||
        array[array.length - 1].answerType == "Multiple Choice") &&
      array[array.length - 1].options.length == 0
    ) {
      dispatch(
        showAlert({
          title: "Question",
          message: "Please fill option first!",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else {
      setAllQuestions((prev) =>
        prev?.map((ques, index) => {
          if (ques.id === currentQues.id) {
            return currentQues;
          } else {
            return ques;
          }
        })
      );
      navigate(-1);
    }
  };

  const doneQNA = () => {
    let array = [currentQues];
    if (!array[array.length - 1].question || !array[array.length - 1].answer) {
      dispatch(
        showAlert({
          title: "Question",
          message: "Please fill Question & Answer first!",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else {
      setAllQuestions((prev) => [...prev, currentQues]);
      setCurrentQues(currentQues);
      setIsAdd(false);
      navigate(-1);
    }
  };

  const updateQNA = () => {
    let array = [currentQues];
    if (!array[array.length - 1].question || !array[array.length - 1].answer) {
      dispatch(
        showAlert({
          title: "Question",
          message: "Please fill Question & Answer first!",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else {
      setAllQuestions((prev) =>
        prev?.map((ques, index) => {
          if (ques.id === currentQues.id) {
            return currentQues;
          } else {
            return ques;
          }
        })
      );
      navigate(-1);
    }
  };

  const addNewOption = () => {
    setCurrentQues((prev) => ({
      ...prev,
      options: prev.options
        ? [...prev.options, { option: "New Option", selected: false }]
        : [{ option: "New Option", selected: false }],
    }));
  };

  const changeOption = (e, i) => {
    setCurrentQues((prev) => ({
      ...prev,
      options: prev.options?.map((option, index) => {
        if (index === i) {
          return { option: e.target.value, selected: false };
        } else {
          return option;
        }
      }),
    }));
  };
  // const idGenerate = () =>{
  //   if(allQuestions?.length == 0){
  //     return 1
  //   }else{
  //     return allQuestions[allQuestions?.length - 1]?.id + 1
  //   }
  // }

  const newQuestion = {
    index: allQuestions?.length,
    id: allQuestions?.length + 1,
    question: "",
    answer: "",
    answerType: "Description",
    // desc: "",
    isOpen: false,
  };

  const handleDone = () => {
    if (isAdd) {
      done();
    } else {
      updateQuestions();
      // navigate(-1);
    }
  };
  const handleDoneQNA = () => {
    if (isAdd) {
      doneQNA();
    } else {
      updateQNA();
      // navigate(-1);
    }
  };

  const handleDropdown = (value) => {
    setCurrentQues((prev) => ({ ...prev, answerType: value, options: [] }));
  };

  const onDelete = (index) => {
    let array = [...allQuestions];
    if (array.length == 1) return;
    array.splice(index, 1);
    setAllQuestions(array);
    dispatch(
      showAlert({
        type: "Success",
        message: "Question deleted",
      })
    );
  };

  return (
    <Row gutter={[32, 16]} className={styles.mainContainer}>
      <Col xs={24} lg={10} className={styles.innerContainer}>
        {allQuestions?.map((ques, i) => (
          <Question
            ques={ques}
            setAllQuestions={setAllQuestions}
            index={i}
            setCurrentQues={setCurrentQues}
            setIsAdd={i}
            setID={setID}
          />
        ))}
        <div className={styles.innerContainer3}>
          <AiFillPlusCircle
            className={styles.icon}
            size={40}
            onClick={() => {
              setIsAdd(true);
              setCurrentQues(newQuestion);
            }}
          />
          <TextComponent text={"Add Question "} textClass={styles.addText} />
        </div>
      </Col>
      <Col xs={24} lg={14} className={styles.renderContainer}>
        <div className={styles.innerContainer4}>
          <div className={styles.containerHeader1}>
            <TextComponent
              textClass={styles.innertext2}
              text={isAdd ? "Add New Question" : `Question#${getIndex() + 1}`}
            />
          </div>
          <InputField
            label="Question"
            styles={styles.innerText4}
            labelClass={styles.innerText4Label}
            rightIcon={CloseIcon}
            onRightIconPress={() =>
              // console.log("currentQuesIndexxxx", currentQues)
              onDelete(currentQues?.index)
            }
            value={currentQues?.question}
            onChange={(e) =>
              setCurrentQues((prev) => ({ ...prev, question: e.target.value }))
            }
          />
          {state.headrTitle == "Add Tidbits" && (
            <DropDown
              selectedValue={currentQues.answerType}
              options={option}
              onChange={handleDropdown}
              stylesClasss={styles.dropdownStyle}
              stylesClass={styles.dropdownContainer}
              labelClass={styles.dropdown}
              label="Select Answer Type"
            />
          )}
          {currentQues.answerType?.toLowerCase() === "description" ? (
            <>
              <div className={styles.middlecontainer}>
                <TextComponent
                  text={"Add Description"}
                  textClass={styles.text}
                />
              </div>

              <div className={styles.main_input}>
                <textarea
                  className={styles.mainInput}
                  disabled={state.headrTitle == "Add Tidbits" ? true : false}
                  placeholder="Write here...."
                  value={currentQues?.answer}
                  onChange={(e) =>
                    setCurrentQues((prev) => ({
                      ...prev,
                      answer: e.target.value,
                    }))
                  }
                />
              </div>
            </>
          ) : null}
          {currentQues.answerType?.toLowerCase() === "multiple choice" ? (
            <>
              {currentQues?.options?.map((option, i) => (
                <>
                  <div className={styles.middlecontainer}>
                    <TextComponent
                      text={`Option ${i + 1}`}
                      textClass={styles.text}
                    />
                  </div>
                  <div className={styles.mainInput1}>
                    <InputField
                      value={option.option}
                      onChange={(e) => changeOption(e, i, "multiple choice")}
                    />
                    {/* <TextComponent text={option} textClass={styles.text} /> */}
                  </div>
                </>
              ))}
              <div className={styles.innerContainer6}>
                <IoMdAdd
                  className={styles.icon}
                  size={30}
                  onClick={() => addNewOption()}
                />
                <TextComponent
                  text={"Add Option"}
                  textClass={styles.addText1}
                />
              </div>
            </>
          ) : null}
          {currentQues.answerType?.toLowerCase() === "options" ? (
            <>
              {currentQues?.options?.map((option, i) => (
                <>
                  <div className={styles.middlecontainer}>
                    <TextComponent
                      text={`Option ${i + 1}`}
                      textClass={styles.text}
                    />
                  </div>
                  <div className={styles.mainInput2}>
                    <div
                      // onClick={() => {
                      //   setIsSelect(!isSelect);
                      // }}
                      // className={isSelect ? styles.checkBox1 : styles.checkBox}
                      className={styles.checkBox1}
                    >
                      {/* {isSelect ? ( */}
                      <AiOutlineCheck className={styles.icon1} size={11} />
                      {/* // ) : null} */}
                    </div>
                    <InputField
                      value={option.option}
                      onChange={(e) => changeOption(e, i)}
                    />
                    {/* <TextComponent text={option} textClass={styles.text} /> */}
                  </div>
                </>
              ))}
              <div className={styles.innerContainer6}>
                <IoMdAdd
                  className={styles.icon}
                  size={30}
                  onClick={() => addNewOption()}
                />
                <TextComponent
                  text={"Add Option"}
                  textClass={styles.addText1}
                />
              </div>
            </>
          ) : null}
        </div>
        <SubmitButton
          btnClass={styles.btnClass}
          title="Done"
          onClick={
            state.headrTitle == "Add Tidbits" ? handleDone : handleDoneQNA
          }
          // onClick={()=>done()}
        />
      </Col>
    </Row>
  );
};

export default AddQuestions;
